module.exports = __webpack_public_path__ + "img/favicon.462aa456.png";